import { render, staticRenderFns } from "./Create-Payment.vue?vue&type=template&id=74c1b1ee"
import script from "./Create-Payment.vue?vue&type=script&lang=js"
export * from "./Create-Payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports